export const therapyAreas = [
  "rarehaematology",
  "raregeneticdisease",
  "oncology",
  "immunology",
  "gastroenterology",
];
